import { MarkerClusterer } from '@react-google-maps/api';
import { Clusterer } from '@react-google-maps/marker-clusterer';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { deliveryTrackingStore } from '../../store/deliveryTrackingStore';
import { clustererOptions } from 'src/constants/map';
import mapStyle from 'src/constants/mapStyle';
import Map from 'src/view/components/Map/Map/Map';
import MapZoom from 'src/view/components/Map/MapZoom/MapZoom';
import { IClustering } from 'src/view/screens/DeliveryManagementScreen/screens/DeliveryTrackingScreen/types/deliveryTracking';
import './style.scss';

interface IProps {
  className?: string;
  mapToolsClassName?: string;
  clustering?: IClustering;
  onMapLoad?: () => void;
  children?: ReactNode;
}

const DeliveryTrackingMapContainer = observer((props: IProps): JSX.Element => {
  const onZoomIn = () => {
    deliveryTrackingStore.mapStore.setZoom((deliveryTrackingStore.mapStore.zoom || 0) + 1);
  };

  const onZoomOut = () => {
    deliveryTrackingStore.mapStore.setZoom((deliveryTrackingStore.mapStore.zoom || 0) - 1);
  };

  const renderClusterer = (markerClusterer: Clusterer, clust: IClustering): JSX.Element => {
    const { branches, customers } = clust;

    return (
      <>
        {branches.pins.map((branchPin) => branches.render(branchPin, markerClusterer))}
        {customers.pins.map((customerPin) => customers.render(customerPin, markerClusterer))}
      </>
    );
  };

  const { clustering } = props;

  return (
    <div className={`delivery-tracking-map ${props.className || ''}`}>
      <Map
        mapRef={deliveryTrackingStore.mapStore.ref}
        options={{
          draggable: true,
          zoomControl: false,
          fullscreenControl: false,
          panControl: false,
          disableDoubleClickZoom: true,
          mapTypeControl: false,
          rotateControl: false,
          streetViewControl: false,
          styles: mapStyle,
          scrollwheel: true,
          gestureHandling: 'greedy',
        }}
        onLoad={props.onMapLoad}
      >
        {clustering && (
          <MarkerClusterer options={clustererOptions}>
            {
              // @ts-ignore
              (markerClusterer) => renderClusterer(markerClusterer, clustering) as any
            }
          </MarkerClusterer>
        )}
        {props.children}
      </Map>
      <div className={`delivery-tracking-map__tools ${props.mapToolsClassName || ''}`}>
        <MapZoom onZoomIn={onZoomIn} onZoomOut={onZoomOut} />
      </div>
    </div>
  );
});

export default DeliveryTrackingMapContainer;
